// src/Pages/Dashboard/Changelog.jsx
import React from "react";
import "./Changelog.css"; // Optional: create this for styling

const Changelog = () => {
  const changelogEntries = [
    // {
    //   date: "21-12-2025",
    //   changes: [
    //     "Fixed duplicate sidebar issue on dashboard",
    //     "Added search functionality to Credit Notes, Vendors, Customers",
    //     "Made all list pages fully responsive with card view on mobile",
    //     "Improved print-ready view for Delivery Challans, Expenses, Purchase Orders",
    //   ],
    // },
    // {
    //   date: "20-12-2025",
    //   changes: [
    //     "Upgraded ViewExpenses page to match premium design",
    //     "Added print/save as PDF functionality with clean layout",
    //     "Made all view pages consistent (PO, Expenses, Delivery Challans)",
    //   ],
    // },
    {
      date: "22-12-2025",
      changes: [
        "1. Fix Express api issue.",
        "2. Solve irregular alignment in all table view.",
        "3. Add search bar in all table.",
        "4. Add toggle button in mobile view.",
      ],
    },
    // Add more entries as needed
  ];

  return (
    <div className="changelog-wrapper">
      <div className="changelog-container">
        <h1>Changelog</h1>
        <p className="subtitle">
          Daily progress updates • What I worked on today
        </p>

        <div className="changelog-entries">
          {changelogEntries.map((entry, index) => (
            <div key={index} className="entry">
              <div className="entry-header">
                <h3>{entry.date}</h3>
                <span className="day-count">
                  Day {changelogEntries.length - index}
                </span>
              </div>

              <ul className="changes-list">
                {entry.changes.map((change, i) => (
                  <li key={i}>{change}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <footer className="changelog-footer">
          <p>Only developers can update this changelog.</p>
          <p>Updated daily for transparency and progress tracking.</p>
        </footer>
      </div>
    </div>
  );
};

export default Changelog;
